import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	boards: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	boards: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.boards.boards',
		defaultMessage: 'Boards',
		description: 'Section title for boards',
	},
});
